import Typography from "@mui/material/Typography";
import BoxContent from "../../../../shared/ui/BoxContent";
import Loading from "../../../../shared/ui/Loading";
import FormField from "../../../../shared/form/FormField";

const ItemsIds = ({ loading, errors, itemsIds, handleInputChange }: any) => {
    return (
        <>
            <Typography variant="h3" mt={3} mb={3}>
                Introdu id-urile itemilor, separate prin virgula
            </Typography>
            <Typography variant="body1" mb={3}>
                Exemplu: 1445,267,3890,465,5897
            </Typography>
            <BoxContent>
                {loading.loading && loading.name === "tag" ? (
                    <Loading show={true} />
                ) : (
                    <FormField
                        name="items_ids"
                        type="text-controlled"
                        label="Introdu id-urile itemilor"
                        value={itemsIds}
                        onChange={handleInputChange}
                        errorMessage={errors.items_ids?.message}
                        error={!!errors.items_ids?.message}
                    />
                )}
            </BoxContent>
        </>
    )
}

export default ItemsIds